import styled from 'styled-components';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

const CardImg = styled.img`
  max-height: 70px;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;
  margin-bottom: 15px;
`;

const CardWrapper = styled.div`
  width: 280px;
  text-align: center;
  border-radius: 8px;
  margin-top: 40px;
  @media only screen and (max-width: 650px) {
    margin: 0 auto;
  }
`;

const Card = props => (
  <CardWrapper className="">
    <div className="card-image">
      <CardImg src={props.imgurl} />
    </div>
    <div style={{ paddingTop: '0px' }} className="card-content">
      <div style={{ fontSize: '24px', paddingBottom: '15px' }}>{props.data}</div>
    </div>
    <div style={{color:'#667988'}}>
        {props.moreText}
    </div>
  </CardWrapper>
);

const Cards = styled.div`
    justify-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  @media only screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }
  @media only screen and (max-width: 650px) {
    grid-template-columns: 1fr;
  }
`;

const CardComp = props =>
  props.cards ? props.cards.map(card => <Card imgurl={card.imgurl} data={card.data} moreText={card.moreText} />) : '';

export default () => {
  const [cardData, setCardData] = useState('');
  axios
    .get('https://api.sheety.co/be602377-b127-449a-baa2-5b8f0bb272f2')
    .then(resp => setCardData(resp.data.slice(6, 12)));
  return (
    <Cards>
      <CardComp cards={cardData} />
    </Cards>
  );
};
